import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { loadStripe } from '@stripe/stripe-js';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-payment-popup',
  templateUrl: './payment-popup.component.html',
})
export class PaymentPopupComponent implements OnChanges {
  @Input() showPaymentModal = false;
  @Input() session: any; // pass session with clientSecret from parent

  @Output() closePaymentModal = new EventEmitter<void>();
  @Output() paymentSuccess = new EventEmitter<void>();

  embeddedCheckout: any = null;
  stripe: any;

  async ngOnChanges(changes: SimpleChanges) {
    if (changes['showPaymentModal'] && this.showPaymentModal) {
      await this.openPaymentModal();
    }
    if (changes['showPaymentModal'] && !this.showPaymentModal) {
      this.destroyStripeElements();
    }
  }


  async openPaymentModal(): Promise<void> {
    console.log('openPaymentModal');
    await new Promise((resolve) => setTimeout(resolve, 200));
    await this.initializeStripeElements();
  }

  async initializeStripeElements(): Promise<void> {
    try {
      if (!this.stripe) {
        this.stripe = await loadStripe(environment.STRIPE_PUBLISHABLE_KEY);
      }

      const fetchClientSecret = async () => {
        return this.session?.clientSecret;
      };

      this.embeddedCheckout = await this.stripe.initEmbeddedCheckout({
        fetchClientSecret,
      });

      this.embeddedCheckout.mount('#checkout-element');
    } catch (error) {
      console.error('Error initializing Stripe elements:', error);
      // Show error toast or emit error event as needed
    }
  }

  close() {
    // this.showPaymentModal = false;
    this.destroyStripeElements();
    this.closePaymentModal.emit();
  }

  destroyStripeElements(): void {
    if (this.embeddedCheckout) {
      this.embeddedCheckout.destroy();
      this.embeddedCheckout = null;
    }
  }

  // Call this when payment success confirmed, e.g. on Stripe events/callbacks
  onPaymentSuccess() {
    this.paymentSuccess.emit();
    this.close();
  }
}
